export default __webpack_public_path__ + "static/media/ringoffire.364481d1.png";